import React from 'react';

interface HoldingItem {
  name: string;
  percentage: number;
  color: string;
}

interface HoldingsCardProps {
  title: string;
  holdings: HoldingItem[];
}

const HoldingsCard: React.FC<HoldingsCardProps> = ({ title, holdings }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold text-gray-900">{title}</span>
      </div>
      <div className="flex flex-col gap-1">
        {holdings.map((holding, index) => (
          <div key={index} className="flex items-center gap-3 min-h-[20px]">
            <span className="text-xs text-gray-900 w-12">{holding.name}</span>
            <div className="flex items-center gap-1">
              <div className="w-16 h-1 bg-gray-200 rounded-full">
                <div
                  className="h-1 rounded-full"
                  style={{
                    width: `${holding.percentage}%`,
                    backgroundColor: holding.color
                  }}
                />
              </div>
              <span className="text-xs text-gray-900">{holding.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HoldingsCard;
